import BrokerageReportLine from './BrokerageReportLine';

export default class BrokerageReport {
  values: BrokerageReportLine[];

  totals: BrokerageReportLine;
}
